module.exports = __webpack_public_path__ + "img/coupon-bg.4db74a57.png";